import AccountCircle from "@mui/icons-material/AccountCircle";
import {
  Button,
  Menu,
  PopoverOrigin,
  Theme,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useAuthProvider, useGetIdentity, useTranslate } from "ra-core";
import { ReactNode, useCallback, useMemo, useState } from "react";
import { Logout } from "react-admin";

const UserMenu = (props: UserMenuProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const translate = useTranslate();
  const { isPending, identity } = useGetIdentity();
  const authProvider = useAuthProvider();
  const isLargeEnough = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up("sm")
  );

  const {
    children = !!authProvider ? <Logout /> : null,
    className,
    label = "ra.auth.user_menu",
    icon = defaultIcon,
  } = props;

  const handleMenu = (event: any) => setAnchorEl(event.currentTarget);
  const handleClose = useCallback(() => setAnchorEl(null), []);
  const context = useMemo(() => ({ onClose: handleClose }), [handleClose]);
  if (!children) return null;
  const open = Boolean(anchorEl);

  return (
    <Root className={className}>
      <Button
        aria-label={label && translate(label, { _: label })}
        className={UserMenuClasses.userButton}
        color="inherit"
        onClick={handleMenu}
        variant="outlined"
        sx={{
          border: "none",
          textTransform: "none",
          m: 0,
          width: "auto",
        }}
      >
        {icon}
      </Button>
      <Menu
        id="menu-appbar"
        disableScrollLock
        anchorEl={anchorEl}
        anchorOrigin={AnchorOrigin}
        transformOrigin={TransformOrigin}
        open={open}
        onClose={handleClose}
        sx={{ height: "500px" }}
      >
        {children}
      </Menu>
    </Root>
  );
};

export interface UserMenuProps {
  children?: ReactNode;
  className?: string;
  label?: string;
  icon?: ReactNode;
}

const PREFIX = "RaUserMenu";

export const UserMenuClasses = {
  userButton: `${PREFIX}-userButton`,
  avatar: `${PREFIX}-avatar`,
};

const Root = styled("div", {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  [`& .${UserMenuClasses.userButton}`]: {
    textTransform: "none",
    marginInlineStart: theme.spacing(0.5),
  },

  [`& .${UserMenuClasses.avatar}`]: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}));

const defaultIcon = <AccountCircle />;

const AnchorOrigin: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "right",
};

const TransformOrigin: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};

export default UserMenu;
